export * from './getPlatform';
